import React, { useEffect, useState } from "react";
import { Button, Paper, Stack, Typography, styled, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import splashBack from "../assets/images/login-back.webp"
import logo from "../assets/images/Logo-Light.svg"
import GeneralModal from "components/datadisplay/modals/GeneralModal";
import LoginMain from "components/Login/LoginMain";
import { SplashInfoPrimary, SplashInfoSecondary } from "components/typography/text";
import { ExpandMore } from '@mui/icons-material'

//Styles and Components

const SplashPaper = styled(Paper)(
    ({ theme }) => `
        background: url(${splashBack});
        background-size: cover;
        background-repeat: no-repeat;
        height: 100vh !important;
        margin-top: calc(-80px + 20px);
        margin-bottom: "-160px";
        padding: ${theme.spacing(3.5)};
        padding-top: ${theme.spacing(7.5)};
        border-radius: 0 !important;
    `
)

const SplashButton = styled(Button)(
    ({ theme }) => `
        width: 100%;
        height: 48px;
        color: ${theme.palette.text.primary} !important;
        font-weight: bold;
        box-shadow: ${theme.shadows[2]} !important;
    `
)

export default function SplashPage() {

    const [openLogin, setOpenLogin] = useState(false)
    const [stage, setStage] = useState(1)

    useEffect(() => {
        if(!openLogin) {
            setStage(1)
        }
    }, [openLogin])

    const handleBackButton = () => {

        // Stage == 1 Login (submitting number OR user)
        // Stage == 2 Login with Number (sending code)
        // Stage == 3 Submit User Detail (name and lname)
        // Stage == 4 Login with username (password login)

        // handling different stage in login system

        if(stage == 2) {
            setStage(1)
        } else if(stage == 2) {
            setStage(1)
        } else if(stage == 3) {
            setStage(1)
        } else if(stage == 4) {
            setStage(1)
        }
    }



    return (
        <SplashPaper className="splashPage">
            <Stack sx={{width: "100%", height: "90%"}} justifyContent="space-between">
                <Stack spacing={5} alignItems="center">
                    <img style={{width: "160px"}} src={logo} alt="لوگو پاکسرشت هوم" />
                    <SplashInfoPrimary>پاکسرشت هوم ورود شما به باشگاه مشتریان را خوشامد می گوید.</SplashInfoPrimary>
                    <SplashInfoSecondary>در باشگاه مشتریان پاکسرشت هوم می توانید با اسکن کدهای مندرج روی محصولات، امتیاز کسب کنید و از جوایز ویژه و جذاب بهره مند شوید.</SplashInfoSecondary>
                </Stack>
                <Stack sx={{px: 4}}>
                    <SplashButton
                        onClick={() => setOpenLogin(true)}
                        size="large"
                        variant="contained"
                    >
                        ورود و ثبت نام
                    </SplashButton>
                </Stack>
                <GeneralModal
                    noCloseButton={stage != 1}
                    responsive={true}
                    fullHeight={true}
                    handleBackButton={stage != 1 ? handleBackButton : undefined}
                    open={openLogin}
                    closeFunction={() => setStage(1)}
                    handleOpen={setOpenLogin}
                    children={<LoginMain stage={stage} setStage={setStage} />}
                />
            </Stack>
        </SplashPaper>
    )
}

//Unique Styles
